import { isValidEmail } from '@trip-ux/constants';
import { ValidationErrors } from 'final-form';

export function validateEmail(values, labels: Record<string, string>): ValidationErrors {
  const errors: ValidationErrors = {};

values.contacts?.forEach((contact, contactIndex) => {
    if (contact.email && !isValidEmail(contact.email)) {
      if (!errors.contacts){
        errors.contacts = [];
      }
      errors.contacts[contactIndex] = {
        email: labels.reqValidEmail
      };
    }
  });

  return errors;
}

const requireFields = (value): ValidationErrors => {
  return {
    ...(!value.organizationCode && { organizationCode: 'Please select agency name/code' }),
  };
};

export default function (value): ValidationErrors {
  const errors: { [prop: string]: unknown } = {};

  return {
    ...requireFields(value),
    ...errors
  };
}
